import { BASE_URL } from "@/constants/endpoints";
import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let TransferRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getTransferRequestsApi = async (): Promise<AxiosInstance | null> => {
  if (TransferRequestsApiPromise) return TransferRequestsApiPromise;
  TransferRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return TransferRequestsApiPromise;
};

export interface GetTransferRequestsProps {
  fechaDesde: string;
  fechaHasta: string;
  monto: number;
  nroCuenta: string;
  idSucursal: number[];
  estado: string[];
  usuario: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getTransferRequests = async (props: GetTransferRequestsProps) => {
  const api = await getTransferRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudesTransferencia/GetListadoSolicitudesTransferencia?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetTransferRequestProps {
  id: number;
  usuarioActual: string;
}

export const getTransferRequest = async (
  props: GetTransferRequestProps,
): Promise<TransferRequestDetail | null> => {
  const api = await getTransferRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudesTransferencia/GetDetalleSolicitudTransferencia?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CancelTransferRequestProps {
  id: number;
  idMotivo?: number;
  mensaje?: string;
  usuarioActual?: string;
}

export const cancelTransferRequest = async (
  props: CancelTransferRequestProps,
) => {
  const api = await getTransferRequestsApi();
  if (!api) return null;
  const response = await api.delete(
    `/SolicitudesTransferencia/DeleteCancelarSolicitudTransferencia?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
